import { Fragment } from "react";
import Text from "@amzn/meridian/esm/components/text";
import Theme from "@amzn/meridian/esm/components/theme";
import { typographyH50FontWeight } from "@amzn/meridian-tokens/base/typography";
import { INSIGHT_KIND } from "./whosWho.constants";

const EMPHASIS_TOKENS = { textB100FontWeight: typographyH50FontWeight };

/**
 * Renders the V2 insight selected for a card position. Placement is classified once by
 * classifyWhosWhoInsights before this component is called.
 */

const careerLabel = (insight) => {
  switch (insight.kind) {
    case INSIGHT_KIND.NEW_AMAZONIAN:
      return "🌱 New Amazonian";
    case INSIGHT_KIND.RECENTLY_PROMOTED:
      return "⭐ Recently promoted";
    case INSIGHT_KIND.NEW_ROLE:
      return "🌱 New role";
    case INSIGHT_KIND.NEW_TEAM:
      return "🌱 New team";
    case INSIGHT_KIND.ANNIVERSARY:
      return `🎉 ${insight.years}-year Amazonian`;
    default:
      return null;
  }
};

const EmphasizedText = ({ children }) => (
  <Theme tokens={EMPHASIS_TOKENS}>
    <Text tag="span" type="b100" color="secondary">{children}</Text>
  </Theme>
);

const renderEmphasizedValues = (values, separator) =>
  values.map((value, index) => (
    <Fragment key={`${value}-${index}`}>
      {index > 0 && separator}
      <EmphasizedText>{value}</EmphasizedText>
    </Fragment>
  ));

const relationshipContent = (relationship) => {
  switch (relationship.kind) {
    case INSIGHT_KIND.NETWORK_CONNECTION:
      return (
        <>Connected through {renderEmphasizedValues(relationship.people, " → ")}</>
      );
    case INSIGHT_KIND.MUTUAL_COLLEAGUES:
      return (
        <>You both know {renderEmphasizedValues(relationship.people, ", ")}</>
      );
    case INSIGHT_KIND.SHARED_REPORTING: {
      const managerRoleSuffix = relationship.managerRole
        ? ` · ${relationship.managerRole}`
        : "";
      return (
        <>
          You both reported to <EmphasizedText>{relationship.managerName}</EmphasizedText>
          {managerRoleSuffix}
        </>
      );
    }
    default:
      return null;
  }
};

const InsightSlot = ({ insight }) => {
  if (!insight) return null;

  const label = careerLabel(insight);
  const content = relationshipContent(insight);

  return label
    ? <EmphasizedText>{label}</EmphasizedText>
    : content
      ? <Text type="b100" color="secondary">{content}</Text>
      : null;
};

export default InsightSlot;
